import angular from "angular";
import dcNavigation from "modules/dc-ui/dc-navigation";
import ConfigService from "app/services/ConfigService";
import LocaleService from "app/services/LocaleService";

export default angular
  .module("HeaderComponent", [dcNavigation, ConfigService, LocaleService])
  .component("headerComponent", {
    template: require("./header-component.tpl.html"),
    bindings: {},
    controller: [
      "$scope",
      "ConfigService",
      "LocaleService",
      function ($scope, ConfigService, LocaleService) {
        this.context = ConfigService.getContext();
        this.title = LocaleService.get("title" /*+ this.context*/);
        this.showLogo =
          ["CPY", "CON"].indexOf(this.context) >= 0 ? true : false;

        this.cookiePolicyUrl = ConfigService.get("links.cookiePolicyUrl");
        this.showCookiePolicy = ConfigService.get("showCookiePolicy");
        this.cookiePolicy = LocaleService.get("cookie.policy");
        this.cookieAccept = LocaleService.get("cookie.accept");
        this.cookieDecline = LocaleService.get("cookie.decline");
        this.cookieMessage = LocaleService.get("cookie.message");

        $scope.$on("cookieLaw.decline", () => {
          this.showCookiePolicy = false;
        });

        $scope.$on("cookieLaw.accept", () => {
          this.showCookiePolicy = false;
        });
      },
    ],
  }).name;



// WEBPACK FOOTER //
// ./src/ui/modules/dcb-eaccount/directives/header-component/header-component.js